<template>
  <div>
    <!--
    <div class="page-header">
      <div class="pageTitle">
        <div class="pageName">{{ page.title }}</div>
      </div>
    </div>
    <div class="row">
      <p style="margin: 20px 15px 10px">
        {{ page.desc }}
      </p>
    </div>
    -->
    <div class="row">
      <div class="col-lg-12">
        <!-- 端口状态信息 -->
        <block-cntr
          :btitle="page.blkTitle.portOpticalTable"
          style="height: 100%"
        >
          <!-- 按钮 -->
          <div class="form-inline" style="height: 35px">
            <span style="float: left">
              <div class="btn-group open">
                <div
                  @click="loadport"
                  class="btn"
                  style="padding: 0px"
                  title="refresh"
                >
                  <i class="fa fa-refresh page-tableaction"></i>
                </div>
              </div>
            </span>
          </div>
          <table
            class="table table-hover table-noneborder-top"
            style="overflow-x: auto"
          >
            <thead style="width: 2500px">
              <tr>
                <th
                  v-for="(value, key) in portOpticalTable.brief"
                  :key="key"
                  :title="portOpticalTable.title[key]"
                  v-show="key !== 'vendorname'"
                  :style="{
                    width:
                      key === 'vendorpn' || key === 'serial' ? '100px' : 'auto',
                  }"
                >
                  {{ value }}
                </th>
              </tr>
            </thead>
            <tbody style="height: 280px; width: 2500px">
              <tr v-for="row in portOpticalTable.data" :key="row.port">
                <td
                  v-for="(value, key) in row"
                  :key="key"
                  :title="value"
                  v-show="key !== 'vendorname'"
                  :style="{
                    width:
                      key === 'vendorpn' || key === 'serial' ? '100px' : 'auto',
                  }"
                >
                  <div
                    v-if="key === 'pstatus'"
                    class="fa fa-circle"
                    :style="{
                      color: row.pstatus === 'On' ? '#32CD32' : '#FF4500',
                    }"
                  ></div>
                  <div v-else>{{ value }}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </block-cntr>
      </div>
    </div>
    <info-box :ibox="iBox"></info-box>
    <waiting-box visible="showWaitingBoxDiag" msg="'mWaitingMsg'"></waiting-box>
  </div>
</template>

<script>
import en from "./../lang/en-US.js"
import BlockCntr from "./../components/BlockCntr.vue"
import InfoBox from "./../components/InfoBox.vue"
import { get, post } from "@/utils/http.js"

export default {
  name: "portOptical",
  components: {
    BlockCntr,
    InfoBox,
  },
  data() {
    return {
      page: en.page.portoptical,
      portOpticalTable: "",
      iBox: {},
    }
  },
  created() {
    this.loadport()
  },
  methods: {
    loadport() {
      get("portoptical")
        .then((res) => (this.portOpticalTable = res.data))
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })
    },

    /* 告警弹框 */
    showAlertBox(type, title, txt) {
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },
  },
}
</script>